// Blown-up ornate crown (2K, transparent) — decorative background art. Only for dark, photo-free panels.
const SRC = "/brand/crown-ornate-1200.webp";
const SRCSET = "/brand/crown-ornate-640.webp 640w, /brand/crown-ornate-1200.webp 1200w, /brand/crown-ornate-2000.webp 2000w";

// fit="w": width-driven (w-full). fit="h": height-driven (h-full w-auto) — lets a crown sit exactly on a rule/line.
export const CrownWatermark = ({ className = "", opacity = 0.12, sizes = "(min-width: 1024px) 34vw, 70vw", fit = "w", testid = "crown-watermark" }) => (
  <div className={`pointer-events-none select-none absolute z-0 ${className}`} style={{ opacity }} aria-hidden="true" data-testid={testid}>
    <img src={SRC} srcSet={SRCSET} sizes={sizes} alt="" draggable="false" loading="lazy" decoding="async"
         className={`crown-static block ${fit === "h" ? "h-full w-auto max-w-none" : "h-auto w-full"}`} />
  </div>
);

export default CrownWatermark;
